import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { last } from 'lodash'
import { TreeBranch } from './treeBranch'
import { AssetTreeContext, ParamsContext } from '../qualityMonitoring/qualityMonitoring'

export function AssetTree(): JSX.Element {
    const [firstRenderOpenPaths, setFirstRenderOpenPaths] = useState([])
    const [currentTab, setCurrentTab] = useState('')
    const urlParams = useContext(ParamsContext)
    const assetTree = useContext(AssetTreeContext)

    useEffect(() => {
        setCurrentTab(urlParams.split('/')[0])
    }, [urlParams])
    useEffect(() => {
        if (!firstRenderOpenPaths.length) {
            const paramsArray = urlParams.split('/')
            const pathsFromParams = paramsArray.reduce((acc, param, index) => {
                if (!index) acc.push(param)
                else acc.push(last(acc) + '/' + param)

                return acc
            }, [])

            setFirstRenderOpenPaths(pathsFromParams)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <StyledAssetTree className={'assetTree'}>
            {assetTree.map(country => {
                const { countryName } = country
                const countryPath = `${currentTab}/${countryName}`

                return (
                    <TreeBranch
                        key={countryName}
                        firstRenderOpenPaths={firstRenderOpenPaths}
                        branchName={countryName}
                        path={countryPath}
                        classPath={'country'}
                    >
                        {country.factories.map(factory => {
                            const { factoryName } = factory
                            const factoryPath = `${countryPath}/${factoryName}`

                            return (
                                <TreeBranch
                                    key={factoryName}
                                    firstRenderOpenPaths={firstRenderOpenPaths}
                                    branchName={factoryName}
                                    path={factoryPath}
                                    classPath={'country__factory'}
                                >
                                    {factory.lines.map(line => {
                                        const { lineName } = line
                                        const linePath = `${factoryPath}/${lineName}`

                                        return (
                                            <TreeBranch
                                                key={lineName}
                                                firstRenderOpenPaths={firstRenderOpenPaths}
                                                branchName={lineName}
                                                path={linePath}
                                                classPath={'country__factory--line'}
                                            >
                                                {line.products.map(product => {
                                                    const productPath = `${linePath}/${product.productName}`

                                                    return (
                                                        <TreeBranch
                                                            key={product.productName}
                                                            branchName={product.productName}
                                                            path={productPath}
                                                            classPath={'country__factory--line__product'}
                                                        />
                                                    )
                                                })}
                                            </TreeBranch>
                                        )
                                    })}
                                </TreeBranch>
                            )
                        })}
                    </TreeBranch>
                )
            })}
        </StyledAssetTree>
    )
}

const StyledAssetTree = styled.ul``
